<template>
  <div>
    <el-dialog v-model="answerRecordShow" title="Tips" width="500" :show-close="false">
      <template #header>
        <div class="header">作答记录</div>
        <div class="close_icon" @click="closePopup">
          <el-icon :size="20">
            <CloseBold />
          </el-icon>
        </div>
      </template>
      <div class="dialog_content">
        <div class="content">
          <div class="answer_record_list">
            <div class="answer_record_one flex">
              <div class="record_num">序号</div>
              <div class="record_time">时间</div>
              <div class="record_spend">用时</div>
              <div class="record_spend">得分</div>
              <div class="record_num record_option">操作</div>
            </div>
            <div class="record_list scroll_y hidden_scroll">
              <div class="answer_record_one flex" v-for="(item, index) in answerRecordList" :key="index"
                :class="[index % 2 == 0 ? 'answer_record_one_active' : '']">
                <div class="record_num">{{ index + 1 }}</div>
                <div class="record_time">{{ item.answerTime }}</div>
                <div class="record_spend">{{ $Tools.secondToMinuteFormatNew(item.answerSection) }}</div>
                <div class="record_spend">{{ item.score }}分</div>
                <div class="record_num record_option cursor_pointer text_active" @click="showPaperDetail(item)">详情</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "GjkcH5Unbind",

  data() {
    return {
      answerRecordShow: false,
      answerRecordList: [],
    };
  },

  mounted() { },

  methods: {
    closePopup() {
      this.answerRecordShow = false;
    },
    showPaperDetail(info) {
      this.$emit('showPaperDetail', info)
    }
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
  box-shadow: 0px 0px 20px 0px rgba(100, 94, 94, 0.06);
  border-radius: 10px;
  padding: 0;
  width: 700px;
  //   height: 270px;
  position: relative;
}

:deep(.el-dialog__header) {
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
  text-align: start;
}

.header {
  //   text-align: center;
  //   font-weight: bold;
  font-size: 20px;
  color: #333333;
  line-height: 60px;
  border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #333333;
}

.dialog_content {
  .content {
    width: 100%;
    min-height: 200px;
    overflow: auto;
    font-size: 18px;
    color: #8e8e8e;
    padding: 0 20px 20px;
    box-sizing: border-box;
    line-height: 36px;

    .answer_record_list {
      .answer_record_one {
        font-size: 14px;
        color: #111111;
        height: 45px;
        line-height: 45px;

        .record_num {
          width: 15%;
          text-align: center;
        }

        .record_time {
          width: 30%;
        }

        .record_spend {
          width: 20%;
        }

        .record_option {
          text-align: start;
        }
      }

      .record_list {
        max-height: 500px;
      }

      .answer_record_one_active {
        background: #F7F7FA;
      }
    }
  }
}
</style>
